import { render } from "./daimianshi.vue?vue&type=template&id=ac46c6fa&scoped=true"
import script from "./daimianshi.vue?vue&type=script&lang=js"
export * from "./daimianshi.vue?vue&type=script&lang=js"

import "./daimianshi.vue?vue&type=style&index=0&id=ac46c6fa&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac46c6fa"]])

export default __exports__